export default __webpack_public_path__ + "static/25_34-5f6c084de1ebd066a2d00d59dcdc31db.png";